import { shouldUseMockWithoutSeasonData } from '../utils/mocks';
import { requestPost } from '../utils/request';

const BASE_URL =
  '/api/fieldview/rest/fieldSpatialDefinition/v3/fieldsByFieldUuids';

/**
 * Get Precision Planting field planting and harvest dates for the specified field owner
 * @param {String} fieldUUID
 * @return {Promise} Response
 */
export function requestPrecPlantingSeasons(fieldUUID) {
  const mockFile = shouldUseMockWithoutSeasonData()
    ? 'precisionPlanting/noData'
    : 'precisionPlanting/default';

  return requestPost(BASE_URL, {
    mockFile,
    data: {
      fieldUuids: [fieldUUID],
    },
  });
}
